"use client";
import AuthHeader from "./AuthHeader";
import AuthHero from "./AuthHero";
import Reset from "./Reset";

export default function ResetPassword() {
  return (
    <div className="h-screen flex flex-col lg:flex-row bg-[#F8FAFC] ">
      <AuthHero />

      {/* Right Form */}
      <div className="flex-1 flex flex-col relative bg-white">
        <AuthHeader />

        <Reset />
      </div>
    </div>
  );
}
